import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { ModalLayout } from '../../modal';
import { StyledConfirmText, StyledDeleteIcon } from './delete-room-confirm-modal.styles';
import type { DeleteRoomConfirmModalProps } from './delete-room-confirm-modal.types';
export const DeleteRoomConfirmModal = ({
  handleDeleteRoom,
  isLoading
}: DeleteRoomConfirmModalProps) => {
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const handleRoomInput = () => {
    handleDeleteRoom();
    setOpenModal(false);
  };
  return <ModalLayout open={openModal} openChange={setOpenModal} triggerButtonColor="error" triggerText="Delete room" modalTitleText="Delete room" closeButtonText="Cancel" actionButtonText={isLoading ? 'Deleting room' : 'Delete room'} actionButtonColor="error" handleActionButton={handleRoomInput} showWarnBox={false} customHeaderIcon={<StyledDeleteIcon icon={faExclamationCircle} />} data-sentry-element="ModalLayout" data-sentry-component="DeleteRoomConfirmModal" data-sentry-source-file="delete-room-confirm-modal.tsx">
      <StyledConfirmText data-sentry-element="StyledConfirmText" data-sentry-source-file="delete-room-confirm-modal.tsx">Are you sure you want to delete this room?</StyledConfirmText>
    </ModalLayout>;
};